import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  Typography,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Tabela from "../../../components/Tabela";
import { Acao } from "../../../types/acao";
import { deleteAcao, getAcaoById, getAcoes } from "../../../api/acaoApi";

const Acoes: React.FC = () => {
  const [acoes, setAcoes] = useState<Acao[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [acaoSelecionada, setAcaoSelecionada] = useState<Acao | null>(null);
  const [modalAberta, setModalAberta] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAcoes = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const acoesData = await getAcoes(token);
        setAcoes(acoesData);
      } catch (error) {
        toast.error("Erro ao buscar ações!");
        console.error("Erro ao buscar ações:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAcoes();
  }, []);

  const handleAddAcao = () => {
    navigate("/adicionarAcao");
  };

  const handleEditAcao = (id: string) => {
    navigate(`/editarAcao/${id}`);
  };

  const handleDeleteAcao = async (id: string) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }
      await deleteAcao(token, id);
      setAcoes(acoes.filter((acao) => acao.id !== Number(id)));
      toast.success("Ação excluída com sucesso!");
    } catch (error) {
      toast.error("Erro ao excluir ação!");
      console.error("Erro ao excluir ação:", error);
    }
  };

  const handleViewAcao = async (id: string) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }
      const acaoData = await getAcaoById(token, id);
      setAcaoSelecionada(acaoData);
      setModalAberta(true);
    } catch (error) {
      toast.error("Erro ao carregar detalhes da ação!");
      console.error("Erro ao carregar detalhes da ação:", error);
    }
  };

  const handleFecharModal = () => {
    setModalAberta(false);
  };

  const colunas = [
    { id: "id", label: "ID" },
    { id: "checklist", label: "Checklist" },
    { id: "tipo_usuario.nome_tipo", label: "Tipo" },
    { id: "modelo.descricao_modelo", label: "Modelo" },
    { id: "ordem_acao", label: "Ordem da Ação" },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Tabela
        titulo="Ações"
        colunas={colunas}
        dados={acoes}
        onAdd={handleAddAcao}
        onEdit={handleEditAcao}
        onView={handleViewAcao}
        onDelete={handleDeleteAcao}
        showVisibilityIcon={true}
        loading={loading}
      />
      <Modal open={modalAberta} onClose={handleFecharModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            minWidth: "50%",
          }}
        >
          {acaoSelecionada ? (
            <>
              <Typography variant="h6">Detalhes da Ação:</Typography>
              <Typography variant="body1">ID: {acaoSelecionada.id}</Typography>
              <Typography variant="body1">
                Checklist: {acaoSelecionada.checklist}
              </Typography>
            
              <Typography variant="body1">
                Ordem da Ação: {acaoSelecionada.ordem_acao}
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={handleFecharModal}
                >
                  Fechar
                </Button>
              </Box>
            </>
          ) : (
            <Typography variant="body1">
              Nenhuma informação disponível.
            </Typography>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default Acoes;
